///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { BomDeviceDTO, GtthKeyValueDTO, ProductAccessoryTypeEnum } from '../../../../generated/shared-types.model';

export class BomDeviceConfigModel {
    constructor(
        public value: Record<number, GtthKeyValueDTO>,
        public availableList: Record<number, GtthKeyValueDTO[]>
    ) {}

    public setValuesToBomDevice(device: BomDeviceDTO) {
        device.antennaAccessoryId = this.value[ProductAccessoryTypeEnum.ANTENNA].key;
        device.mountingKitId = this.value[ProductAccessoryTypeEnum.MK].key;
        device.poeId = this.value[ProductAccessoryTypeEnum.POWER_INJECTORS].key;
        device.srgId = this.value[ProductAccessoryTypeEnum.SRG].key;
        device.sfpId = this.value[ProductAccessoryTypeEnum.SFP].key;
        device.capacityLicenseId = this.value[ProductAccessoryTypeEnum.SOFTWARE_UPGRADE].key;
        device.pseId = this.value[ProductAccessoryTypeEnum.OPT_PSE].key;
        device.l2Id = this.value[ProductAccessoryTypeEnum.OPT_L2].key;
        device.extendmmId = this.value[ProductAccessoryTypeEnum.OPT_EXTENDMM].key;
        device.syncId = this.value[ProductAccessoryTypeEnum.OPT_SYNC].key;
        device.aesId = this.value[ProductAccessoryTypeEnum.OPT_AES].key;

        device.antennaName = this.value[ProductAccessoryTypeEnum.ANTENNA].value;
        device.mountingKit = this.value[ProductAccessoryTypeEnum.MK].value;
        device.poe = this.value[ProductAccessoryTypeEnum.POWER_INJECTORS].value;
        device.srg = this.value[ProductAccessoryTypeEnum.SRG].value;
        device.sfp = this.value[ProductAccessoryTypeEnum.SFP].value;
        device.capacityLicense = this.value[ProductAccessoryTypeEnum.SOFTWARE_UPGRADE].value;
        device.pse = this.value[ProductAccessoryTypeEnum.OPT_PSE].value;
        device.l2 = this.value[ProductAccessoryTypeEnum.OPT_L2].value;
        device.extendmm = this.value[ProductAccessoryTypeEnum.OPT_EXTENDMM].value;
        device.sync = this.value[ProductAccessoryTypeEnum.OPT_SYNC].value;
        device.aes = this.value[ProductAccessoryTypeEnum.OPT_AES].value;

        if (device.deviceSectorsConfig?.length > 0) {
            device.deviceSectorsConfig.forEach((sectorConfig) => {
                if (sectorConfig.enabled) {
                    sectorConfig.capacityLicenseId = this.value[ProductAccessoryTypeEnum.SOFTWARE_UPGRADE].key;
                    sectorConfig.capacityLicense = this.value[ProductAccessoryTypeEnum.SOFTWARE_UPGRADE].value;
                }
            });
        }
    }
}
